import Box from "@mui/material/Box";
import {ReactNode, useLayoutEffect, useRef, useState} from "react";

interface PrintPreviewScalerProps {
    pageWidth: number
    children: ReactNode
}

export default function PrintPreviewScaler({pageWidth, children}: PrintPreviewScalerProps) {
    const wrapperRef = useRef<HTMLDivElement | null>(null);
    const contentRef = useRef<HTMLDivElement | null>(null);
    const [availableWidth, setAvailableWidth] = useState(0);
    const [contentHeight, setContentHeight] = useState(0);

    useLayoutEffect(() => {
        const updateSizes = () => {
            setAvailableWidth(wrapperRef.current?.clientWidth ?? 0);
            setContentHeight(contentRef.current?.offsetHeight ?? 0);
        };

        updateSizes();
        const observer = new ResizeObserver(updateSizes);
        if (wrapperRef.current) observer.observe(wrapperRef.current);
        if (contentRef.current) observer.observe(contentRef.current);
        return () => observer.disconnect();
    }, []);

    const scale = availableWidth > 0 ? Math.min(1, availableWidth / pageWidth) : 1;

    return (
        <Box ref={wrapperRef} sx={{width: '100%', display: 'flex', justifyContent: 'center'}}>
            <Box sx={{width: pageWidth * scale, height: contentHeight * scale}}>
                <Box ref={contentRef} sx={{width: pageWidth, transform: `scale(${scale})`, transformOrigin: 'top left'}}>
                    {children}
                </Box>
            </Box>
        </Box>
    );
}
